import type {
  GetServerSidePropsContext,
  GetServerSidePropsResult,
  NextPage,
} from "next";
import { MainLayout } from "src/presentation/layouts";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { CountryLocationService } from "@services/country-location-service";
import { settings } from "@config/settings";
import { localesParserDictionary } from "@utils/locales-parser";
import { EntitiesFetcherService } from "@services/entities-fetcher";
import { MainRouter } from "@config/urls";
import styles from "./productosnoencontrado.module.scss";
import { useTranslation } from "next-i18next";
import { NextSeo } from "next-seo";
import { ProductosService } from "@services/productos-service";
import { SimpleLink } from "src/presentation/components/atoms";

const ProductoNoEncontrado: NextPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <NextSeo
        title={t("productnotfinder.title") || ""}
        description={t("productnotfinder.description") || ""}
      />
      <MainLayout
        breadcrumb={[
          {
            label: t("urls.home"),
            url: MainRouter.home.generatePath(),
          },
          {
            label: t("urls.productos"),
            url: MainRouter.productos.generatePath(),
          },
        ]}
      >
        <div className={styles.root}>
          <h1 className={styles.paddingelementso}>
            {t("productnotfinder.text1")}
          </h1>{" "}
          <h1 className={styles.paddingelementso}>
            {t("productnotfinder.text2")}
          </h1>
          <p className={styles.paddingelementso}>
            {t("productnotfinder.text3")}
          </p>
          <div className={styles.paddingelementso}>
            <SimpleLink
              strong
              link={MainRouter.contactanos.generatePath()}
              label={t("productnotfinder.text4")}
            />
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export async function getServerSideProps(
  Props: GetServerSidePropsContext
): Promise<GetServerSidePropsResult<any>> {
  const { locale, req, params, res } = Props;
  const productoId = params?.id as string;
  let selectedCountry =
    await new CountryLocationService().getSelectedCountryData(req, res);

  const opts = {
    locale: localesParserDictionary[locale || settings.DEFAULT_LANG],
    country: selectedCountry.countrycode,
  };

  const entities = await new EntitiesFetcherService().getEntities({
    ...opts,
    productosDestacados: true,
    gruposDeCultivo: true,
    productosGenericos: true,
  });

  const result = await new ProductosService().getProductoDetalle({
    ...opts,
    slug: productoId,
  });

  return {
    props: {
      country: selectedCountry.countrycode,
      productoDetalle: JSON.stringify(result),
      productosGenericos: JSON.stringify(entities.productosGenericosData),
      productosDestacadosData: JSON.stringify(entities.productosDestacadosData),
      gruposDeCultivoData: JSON.stringify(entities.gruposDeCultivoData),
      ...(await serverSideTranslations(locale || settings.I18N_FALLBACK, [
        "common",
      ])),
    },
  };
}

export default ProductoNoEncontrado;
